export default __webpack_public_path__ + "static/media/rate-property-condition.6b7c437d.svg";